import axios from 'axios';
import { Configuration } from '../models/configuration';

class ProposalWebservice {

    /**
     * Call the calculate proposal method on api
     *
     * @param configuration Configuration
     */
    public calculate(configuration: Configuration) {
        return axios.post('/proposals/calculate', {
            configuration,
        });
    }

}

export const proposalWebservice = new ProposalWebservice();
